module.exports = {"30x36": __webpack_public_path__ + "images/satellite-sputnik-36x30.png"};